import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { TeamSettingsDetailViewTopBar } from "./TopBar"

export const teamSettingsDetailsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: TeamSettingsDetailViewTopBar,
}
